import Layout from '@/components/layout'
import {PrimaryNewsletterCta} from '@/components/primary-newsletter-cta'

const NewsletterPage = () => {
  return (
    <Layout className="w-full">
      <main className="w-full mx-auto">
        <PrimaryNewsletterCta />
      </main>
    </Layout>
  )
}

export default NewsletterPage
